import editor from '@/API/services/enveditor';
import miniToastr from 'mini-toastr';

export default {
  state: {
    variables: {},
    version: 1,
    variablesArray: [],
  },
  mutations: {
    UPDATE_VARIABLES: (state, payload) => {
      state.variablesArray = payload;
      const variablesObject = {};

      state.variablesArray.forEach(item => {
        variablesObject[item.key] = item.value;
      });

      state.variables = variablesObject;
    },
    SET_VARIABLES: (state, payload) => {
      const variablesArray = [];
      const variablesObject = {};

      if (payload.version == undefined) {
        console.log(`error: ${payload} is not the right format`)
        return
      }

      const data = JSON.parse(payload.data);

      Object.keys(data).forEach(key => {
        variablesArray.push({
          key: key,
          value: data[key],
        });
      });

      variablesArray.forEach(item => {
        variablesObject[item.key] = item.value;
      });

      state.variables = variablesObject;
      state.variablesArray = variablesArray;
      state.version = payload.version;
    },
  },
  actions: {
    fetchVariables: async ({ commit }, payload) => {
      try {
        const { data } = await editor.getVariables(payload);
        await commit('SET_VARIABLES', data);
      } catch(err) {
        console.log(err);
      }
    },
    updateVariables: ({ commit }, payload) => {
      commit('UPDATE_VARIABLES', payload);
    },
    saveVariables: async (state, payload) => {
      try {
        await editor.saveVariable(payload);
        miniToastr.success('You have saved your settings', ' ');
      } catch(err) {
        console.log(err);
      }
    },
  }
};
